import { Link } from "react-router";
import { Trans, useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { InstallButton } from "../components/InstallButton";
import "./home.css";

interface HomeStats {
  availableBooks: number;
  exchangesThisMonth: number;
}

export function Home() {
  const { t } = useTranslation();
  const stats = useQuery<HomeStats>({
    queryKey: ["stats", "home"],
    queryFn: () => api<HomeStats>("/api/stats/home"),
    staleTime: 5 * 60 * 1000,
  });
  return (
    <div className="container home">
      <section className="hero" aria-labelledby="hero-title">
        <div className="hero__copy">
          <span className="hero__edition">{t("home.edition")}</span>
          <h1 id="hero-title" className="hero__headline">
            <Trans i18nKey="home.heroHeadline">
              livros que <em>passam</em> de mão em mão.
            </Trans>
          </h1>
          <p className="hero__subhead">{t("home.heroSubhead")}</p>
          <div className="hero__actions">
            <Link to="/browse" className="btn btn-primary">
              {t("home.ctaBrowse")}
            </Link>
            <Link to="/donate" className="btn btn-secondary">
              {t("home.ctaDonate")}
            </Link>
            <InstallButton />
          </div>
        </div>

        <aside className="stats" aria-label={t("home.statsThisWeek")}>
          <p className="stats__eyebrow">{t("home.statsThisWeek")}</p>
          <p className="stats__num">{stats.data?.availableBooks ?? "—"}</p>
          <p className="stats__caption">{t("home.statsBooksAvailable")}</p>
          <hr className="stats__rule" />
          <p className="stats__num">{stats.data?.exchangesThisMonth ?? "—"}</p>
          <p className="stats__caption">{t("home.statsExchangesThisMonth")}</p>
        </aside>
      </section>

      <section className="how" aria-labelledby="how-title">
        <h2 id="how-title" className="how__heading">{t("home.howTitle")}</h2>
        <ol className="how__steps">
          <li>
            <Link to="/donate" className="how__step-link">
              <h3>{t("home.step1Title").replace(/^\d+\.\s*/, "")}</h3>
              <p>
                <Trans i18nKey="home.step1Body">
                  Trazes os teus livros à loja. Por cada livro registado recebes <strong>1 ponto</strong>.
                </Trans>
              </p>
            </Link>
          </li>
          <li>
            <Link to="/browse" className="how__step-link">
              <h3>{t("home.step2Title").replace(/^\d+\.\s*/, "")}</h3>
              <p>{t("home.step2Body")}</p>
            </Link>
          </li>
          <li>
            <Link to="/login" className="how__step-link">
              <h3>{t("home.step3Title").replace(/^\d+\.\s*/, "")}</h3>
              <p>
                <Trans i18nKey="home.step3Body">
                  Reserva um livro com 1 ponto. Tens <strong>7 dias</strong> para o levantar.
                </Trans>
              </p>
            </Link>
          </li>
        </ol>
      </section>
    </div>
  );
}
